// @core/api/endpoints/team/list_role_delegations.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListRoleDelegationsResponse,
} from '../../../types/team';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/team';

/**
 * List role delegations
 * Returns a paginated list of role delegations. Supports filtering and sorting.
 */
export async function ListRoleDelegations(
  team_id: string,
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListRoleDelegationsResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:team_id/delegations`;
  requestPath = requestPath.replace(':team_id', encodeURIComponent(team_id));
  const requestOptions = options;
  return client.get<ListRoleDelegationsResponse>(requestPath, { ...requestOptions, params });
}
